export const removeDot = (str: string) => str.replaceAll(".", "");
